export default "__VITE_ASSET__BBb77EaV__"